import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { JobFunctionCategory } from '@nxtpeople/nxt-styles';
import { LocationQuery } from 'vue-router';
import { JobFunction } from './job-function.interface';

export const JOB_FUNCTION_INCLUDES = [
   'escoStatus',
   'escoStatusCount',
   'jobFunctionCategory',
   'jobFunctionCategoryCount',
   'jobFunctionGroup',
   'jobFunctionGroupCount',
];

export class JobFunctionService {
   async getAll(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<JobFunctionCategory>>>('/nxt-job-function-categories', {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async search(query?: LocationQuery) {
      const response = await http.post<ApiResource<Array<JobFunction>>>('/job-functions/search', { ...cacheFirstConfig, ...query });
      return response.data;
   }
}
